<div
	class="notification-container"
	[ngClass]="{ secondary: notification.read && !isAdminNotification }"
	tabindex="0"
>
	<div class="row">
		<div class="col-md-auto icon-padding">
			@if (
				notification.isApplicationStatusChanged ||
				notification.isAppealStatusChanged
			) {
				<i
					class="fa fa-file-text-o"
					data-cy="notification-status-change-icon"
				></i>
			}
			@if (
				notification.isApplicationCommentChanged ||
				notification.isAppealCommentChanged
			) {
				<i class="fa fa-comments" data-cy="notification-comments-icon"></i>
			}
			@if (notification.isSystemGeneratedEmail) {
				<i class="fa fa-envelope-o" data-cy="notification-sgen-icon"></i>
			}
		</div>
		<div class="col">
			<div class="row">
				<div class="col">
					@if (
						notification.isApplicationStatusChanged ||
						notification.isAppealStatusChanged
					) {
						<span
							class="aut-status-change"
							data-cy="status-change-notification-title"
						>
							{{ notificationObjectType | titlecase }} Status change:
						</span>
					}
					@if (
						notification.isApplicationCommentChanged ||
						notification.isAppealCommentChanged
					) {
						<span
							class="aut-comment-change"
							data-cy="comment-notification-message"
						>
							{{
								(
									this.hideAppealApproverName &&
									notification.firstName !== 'Edassist' &&
									notification.lastName !== 'Admin'
								) ?
									'Program Administrator'
								:	notification.firstName + ' ' + notification.lastName
							}}
							added a comment to your {{ notificationObjectType | titlecase }}.
						</span>
					}
					@if (notification.isSystemGeneratedEmail) {
						<span class="aut-sgen" data-cy="sgen-notification-title">
							System Generated Email:
						</span>
					}
				</div>
				<div
					class="col justify-content-end d-flex notification-date aut-date-stamp"
				>
					<span
						class="aut-date"
						data-cy="notification-tile-date"
						[ngClass]="{ 'notification-padding': notification.read }"
						>{{ notification.eventDate | date }}</span
					>
					@if (!this.notification.read && !this.isAdminNotification) {
						<i
							class="fa fa-circle"
							data-cy="new-notification-circle"
							(click)="markAsRead()"
						></i>
					}
				</div>
			</div>
			<div class="row">
				@if (
					notification.isApplicationStatusChanged ||
					notification.isAppealStatusChanged
				) {
					<div
						class="col bold-text aut-status-change-value"
						data-cy="status-change-notification-status"
					>
						{{ notification.eventValue | titlecase }}
					</div>
				}
				@if (
					notification.isSystemGeneratedEmail &&
					notification.emailNotification?.subject
				) {
					<div
						class="col bold-text aut-sgen-value"
						data-cy="sgen-notification-subject"
					>
						{{ notification.emailNotification?.subject | titlecase }}
					</div>
				}
				<div class="col d-flex justify-content-end aut-time-stamp">
					<span [ngClass]="{ 'notification-padding': notification.read }" class="notification-padding" data-cy="notification-tile-time"
						>{{ notification.eventDate | date: 'hh:mm a' }}
						{{ notificationTimeZone }}</span
					>
				</div>
			</div>
			<div class="row">
				<div class="col view-link-margin aut-application-link">
					<ea-button-link
						(onClick)="navigateToApplication()"
						data-cy="notification-application-number-link"
					>
						View {{ notificationObjectType | titlecase }}
						{{ notification.applicationNumber }}
					</ea-button-link>
				</div>
				@if (notification.emailNotification) {
					<div
						class="col justify-content-end d-flex view-link-margin show-email aut-mail-link"
					>
						<ea-button-link
							(onClick)="toggleEmail()"
							data-cy="notification-show-email-link"
						>
							{{ toggleEmailText | titlecase }}
						</ea-button-link>
					</div>
				}
			</div>
		</div>
	</div>
	@if (showEmail) {
		<div class="email-container aut-email-container send-email">
			<ea-email
				[email]="notification.emailNotification"
				[isAdminNotification]="isAdminNotification"
				data-cy="notification-email-contents"
			></ea-email>
		</div>
	}
</div>
